import { FC, ReactElement } from "react";
import { Container, Grid, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import Navbar from "./Navbar";
import { useTemplateThemeModeContext } from "../../hooks";
import { TemplateThemeModeContextType } from "../../context";
import styles from "../assests/scss/themes-vars.module.scss";

export const Header: FC = (): ReactElement => {
  var mnuHeaderHeight = document.getElementById("sidebarMnuHeader")?.clientHeight
  const theme = useTheme();
  const { isDark } = useTemplateThemeModeContext() as TemplateThemeModeContextType;
  return (
    <Box
      sx={{
        width: "100%",
        height: mnuHeaderHeight,
        backgroundColor: isDark ? theme.palette.common.white : theme.palette.info.light,
        border: `1px solid ${styles.hborderColor}`,
        position: "sticky",
        zIndex: 999,
        top: 0
      }}
    >
      <Container disableGutters maxWidth={false}>
        <Grid container direction="column" alignItems="left" paddingRight={4} flexDirection={'row'}>
          <Grid item md={2}>
            <Typography sx={{ padding: '6px', color: "#a549c6", fontWeight: '800', fontSize: '1.5rem', lineHeight: '1.334', fontFamily: 'poppins' }} component='div'>Innovate</Typography>
          </Grid>
          <Grid item md={10}>
            <Navbar />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Header;